<app-toolbar></app-toolbar>
<div class="container text-center notoolbar">
    <img src="assets/swamy.jpg" alt="image" class="swamy" />
</div>